import { Component, OnInit, Inject } from '@angular/core';
import { TableListTagService } from '../table-list-tag-builder.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ILookup } from '../../../common/interfaces/ILookup.interface';
import { PreviewTableData } from '../table-list-tag-builder.model';
import { ColumnSearchFieldType, IColumn } from '../../../../shared-module/common/interfaces/IColumn.interface';
import { DataTableFilter, FilterType } from '../../../../shared-module/common/models/DataTableFilter.model';
import { CurrentUser } from '../../../../shared-module/common/services/current-user.service';

@Component({
    selector: 'preview-data-table',
    templateUrl: './preview-data-table.component.html',
    providers: [TableListTagService],
    styleUrls: ['./preview-data-table.component.scss'],
    standalone: false
})

export class PreviewDataTableComponent implements OnInit {

  public columnNames: Array<ILookup>;
  public isInit: boolean;
  public filter: DataTableFilter;
  public columns = new Array<IColumn>();
  public previewTableData = new Array<any>();
  public guid: string = 'preview-data-table';

  constructor(private tableListTagService: TableListTagService,
    private currentUser: CurrentUser,
    public dialogRef: MatDialogRef<PreviewDataTableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.initFilter();
    this.initColumns();
  }

  public initColumns(){
    this.tableListTagService.getColumnNames(this.data.tableName).subscribe((columnNames: Array<ILookup>) => {
      this.columnNames = columnNames;

      this.columnNames.forEach(column => {
        this.columns.push(
          {
            prop: column.text,
            name: column.text,
            visible: true,
            width: 130,
            minWidth: 130,
            searchFieldType: ColumnSearchFieldType.text
          }
        );

        this.filter.filters.push(
          {
            name: column.text
          },
        );
      })

      this.initTableData();

    });
  }

  public initFilter() {
    this.filter = new DataTableFilter();
    this.filter.placeholder = 'FormulaBuilder_QuickSearch';
    this.filter.totalCountPlaceholder = 'Admin.AuditTrail.TotalRecords';
    this.filter.quickFilter = '';
  }

  public initTableData() {
    this.tableListTagService.getPreviewDataTable(this.data.tableName).subscribe((previewTableData: PreviewTableData[]) => {
      previewTableData.forEach(tableDataRow => {
        let row = new Array<any>();
        
        this.columnNames.forEach(columnName => {
          row[columnName.text] = tableDataRow.rowValues[this.columnNames.indexOf(columnName)];
        })

        this.previewTableData.push(row);
      })
      
      this.isInit = true;
    });
  }

  public cancel() {
    this.dialogRef.close();
  }
}